module.exports = __webpack_public_path__ + "static/media/cl.pictogram.9f7e416b.svg";